import React from "react";
import { Row, Col, Container, Button, Card } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import search from "assets/image/search-engine.png";
import star from "assets/image/star.png";
import browser from "assets/image/browser-stats.png";

export default function Academy() {
  const { t } = useTranslation();
  const array = [
    {
      src: search,
      text: t("Daily analysis"),
      link: "https://blog.coinnik.market/category/analysis-investing/daily-crypto-price-analysis/",
    },
    {
      src: browser,
      text: t("Technical<br/>analysis training<br/>"),
      link: "https://blog.coinnik.market/category/analysis-investing/technical-analysis/",
    },
    {
      src: star,
      text: t("Familiarity with <br/>digital currencies<br/>"),
      link: "https://blog.coinnik.market/category/review/cryptocurrencies/",
    },
  ];
  return (
    <Container className="py-6">
      <div className="d-flex flex-column justify-content-center align-items-center mb-5">
        <span className="text-warning-light fw-medium pb-2">
          {t("Academy")}
        </span>
        <span className="fs-5 text-primary-light fw-bold">
          {t("Follow our trainings and analyzes")}
        </span>
      </div>
      <Row>
        {array.map((item, i) => (
          <Col
            xs="12"
            sm="12"
            md="12"
            lg="4"
            xl="4"
            className="analysis-box-parent mb-2"
          >
            <div className="  img-bg h-100 w-100 ">
              <Row>
                <Col
                  xs="5"
                  md="5"
                  lg="6"
                  xl="6"
                  className="d-flex align-items-end"
                >
                  <div className="d-flex flex-column">
                    <Trans>
                      <span className="text-white fs-7 fw-bold  ">
                        {item.text}
                      </span>
                    </Trans>
                    <a href={item.link}>
                      <Button className="mt-2" size="md py-2" color="warning">
                        {t("View")}
                      </Button>
                    </a>
                  </div>
                </Col>
                <Col xs="7" md="7" lg="6" xl="6">
                  <div className="d-flex justify-content-end ">
                    <img src={item.src} className="style-img" alt="img" />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
